<template>
  <BuilderWrapper
    title="Basemap"
    helpful-tip="You can use a built-in basemap, or use your own custom tiles."
  >
    <b-form-group>
      <div slot="label">
        <b-radio
          :value="BasemapTypes.DEFAULT"
          :checked="basemapType"
          data-test="radio-basemap-type-default"
          @input="$emit('update:basemapType', $event)"
        >
          Built-in basemaps
        </b-radio>
      </div>
      <b-select
        :value="basemapDefault"
        :options="defaultOptions"
        :disabled="basemapType!==BasemapTypes.DEFAULT"
        data-test="select-basemap-default"
        @input="$emit('update:basemapDefault', $event)"
      />
    </b-form-group>

    <b-form-group>
      <div slot="label">
        <b-radio
          :value="BasemapTypes.CUSTOM"
          :checked="basemapType"
          data-test="radio-basemap-type-custom"
          @input="$emit('update:basemapType', $event)"
        >
          Custom Tiles
        </b-radio>
      </div>
      <LabelledInput
        label="URL"
        helpful-tip="Url should have the form 'https://{s}.domain.com/{z}/{x}/{y}.png'"
      >
        <b-input
          :value="customUrl"
          :disabled="basemapType!==BasemapTypes.CUSTOM"
          data-test="input-basemap-custom-url"
          @input="$emit('update:customUrl', $event)"
        />
      </LabelledInput>
      <LabelledInput
        label="Attribution"
        helpful-tip="Displayed on the map, bottom right"
      >
        <b-input
          :value="customAttribution"
          :disabled="basemapType!==BasemapTypes.CUSTOM"
          data-test="input-basemap-custom-attribution"
          @input="$emit('update:customAttribution', $event)"
        />
      </LabelledInput>
    </b-form-group>
  </BuilderWrapper>
</template>

<script lang="ts">

import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

import BuilderWrapper from '@/components/builder/UI/BuilderWrapper.vue'
import LabelledInput from '@/components/builder/UI/LabelledInput.vue'

import { DefaultMapIDs } from '@/components/builder/MapSettings/defaultMaps'
import { BasemapType, BasemapTypes } from '@/types'

const components = {
  BuilderWrapper,
  LabelledInput,
}

const props = {
  basemapType: {
    type: String as PropType<BasemapType>,
    required: true,
  },
  basemapDefault: {
    type: String,
    required: true,
  },
  customUrl: {
    type: String,
    required: true,
  },
  customAttribution: {
    type: String,
    required: true,
  },
}

@Component({ components })
export default class BasemapConfig extends Vue.extend({ props }) {
  BasemapTypes = BasemapTypes

  get defaultOptions () {
    return DefaultMapIDs
  }
}

</script>
